<template>
  <div class="tw-flex tw-h-full tw-flex-col">
    <!-- hover:tw-bg-gray-50 focus-within:tw-ring-2 focus-within:tw-ring-inset focus-within:tw-ring-indigo-500 -->

    <div class="tw-w-full tw-rounded-t-lg tw-bg-primary-500">
      <div class="tw-flex tw-items-center tw-space-x-2 tw-px-4 tw-py-5">
        <div class="">
          <v-btn
            icon
            small
            class="
              tw-text-white
              tw-normal-case tw-shadow-none
              focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300
            "
            @click="view = 'HOME'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-h-5 tw-w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </v-btn>
        </div>
        <!-- tw-px-4  -->
        <div class="tw-relative tw-flex tw-flex-1 tw-items-center tw-space-x-2">
          <div class="tw-flex-shrink-0">
            <img
              class="tw-h-9 tw-w-9 tw-rounded-full"
              :src="talking_to.avatar"
              alt=""
            />
          </div>
          <div class="tw-min-w-0 tw-flex-1">
            <a href="#" class="focus:tw-outline-none">
              <!--<span-->
              <!--  class="tw-absolute tw-inset-0"-->
              <!--  aria-hidden="true"-->
              <!--  @click="$refs.menuProfileChat.click()"-->
              <!--/>-->
              <p class="tw-mb-0 tw-text-sm tw-font-bold tw-text-gray-50 tw-leading-4">
                {{ talking_to.first_name }} {{ talking_to.last_name }}
              </p>
              <p class="tw-m-0 tw-text-[12px] tw-text-gray-300 tw-truncate tw-leading-4">
                {{ talking_to.is_online ? 'online' : 'offline' }}
              </p>
            </a>
          </div>
          <div class="">
            <AppBtn
              type="button"
              icon="card_view"
              color="transparent-dark"
              fab
              small
              class="tw-shadow-md"
              @click="viewAttendee"
            />
            <AppBtn
              v-if="talking_to.is_online && has_video_chat"
              type="button"
              icon="videocall"
              color="transparent-dark"
              fab
              small
              class="tw-shadow-md"
              @click="startVideoCall"
            />
            <v-menu
              v-if="false"
              offset-y
              transition="scale-transition"
              content-class="tw-py-1 tw-mt-2 tw-bg-white tw-rounded-md tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5"
            >
              <template #activator="{ on, attrs }">
                <button
                  id="project-options-menu-0-button"
                  ref="menuProfileChat"
                  type="button"
                  class="
                    tw-inline-flex
                    tw-h-8
                    tw-w-8
                    tw-items-center
                    tw-justify-center
                    tw-rounded-full
                    tw-bg-white
                    tw-text-gray-400
                    hover:tw-text-gray-500
                    focus:tw-outline-none
                    focus:tw-ring-2
                    focus:tw-ring-primary-500
                    focus:tw-ring-offset-2
                  "
                  aria-expanded="false"
                  aria-haspopup="true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="tw-sr-only">Open options</span>
                  <svg
                    class="tw-h-5 tw-w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                    />
                  </svg>
                </button>
              </template>
              <v-list>
                <v-list-item @click="viewAttendee">
                  <v-list-item-title>{{
                    $t('pages.event.actions.view_card')
                  }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="callUser">
                  <v-list-item-title>Iniciar Videollamada</v-list-item-title>
                </v-list-item> -->
                <v-list-item
                  v-if="talking_to.is_online && has_video_chat"
                  @click="startVideoCall"
                >
                  <v-list-item-title>{{
                    $t('pages.event.actions.start_vchat')
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="false">
                  <v-list-item-title>Silenciar</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="false">
                  <v-list-item-title>Bloquear</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <!-- tw-overflow-x-hidden -->
    <transition name="fade-transition" mode="out-in">
      <div
        v-if="!loading"
        id="messages"
        ref="scrollToMe"
        class="
          tw-scrolling-touch
          scrollbar-thumb-blue
          scrollbar-thumb-rounded
          scrollbar-track-blue-lighter
          scrollbar-w-2
          tw-flex tw-flex-1 tw-flex-col tw-overflow-y-scroll
        "
        @scroll="onMessagesScroll"
      >
        <!-- Se carga solo al acercarse con el scroll; el botón es para cuando
             la página entra en la pantalla y no hay scroll. -->
        <div v-if="hasOlder" class="tw-flex tw-justify-center tw-py-2">
          <v-btn text small :loading="loadingOlder" @click="loadOlder">
            {{ $t('app.chat_status.load_older') }}
          </v-btn>
        </div>
        <div
          v-for="(group, index) in sortedMessages"
          :key="index"
          class="relative"
        >
          <div
            class="
              tw-sticky
              tw-top-0
              tw-z-10
              tw-border-t
              tw-border-b
              tw-border-gray-200
              tw-bg-gray-50
              tw-px-4
              tw-py-1
              tw-text-sm
              tw-font-medium
              tw-text-gray-500
            "
          >
            <h3>{{ index }}</h3>
          </div>
          <div class="tw-space-y-4 tw-p-4">
            <!-- <transition-group name="fade-transition" class="tw-space-y-4 tw-p-4"> -->
            <ChatConversationMessage
              v-for="message in group"
              :key="message.id || message.uuid"
              :message="message"
              :user="user"
              @retry-message="retryMessage"
              @discard-message="discardMessage"
            />
            <!-- </transition-group> -->
          </div>
        </div>
      </div>
      <div
        v-else
        class="
          tw-scrolling-touch
          scrollbar-thumb-blue
          scrollbar-thumb-rounded
          scrollbar-track-blue-lighter
          scrollbar-w-2
          tw-flex tw-flex-1 tw-flex-col tw-overflow-y-scroll
        "
      >
        <v-progress-linear indeterminate color="primary darken-2" />
      </div>
    </transition>
    <div
      class="
        tw-border-t-2 tw-border-gray-200 tw-px-4 tw-pt-2 tw-pb-2
        sm:tw-mb-0
      "
    >
      <form @submit.prevent="submit">
        <div class="tw-relative tw-flex tw-space-x-2">
          <!-- <span class="tw-absolute tw-inset-y-0 tw-flex tw-items-center">
            <button
              type="button"
              class="tw-inline-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-text-gray-500 tw-transition tw-duration-500 tw-ease-in-out tw-rounded-full hover:tw-bg-gray-300 focus:tw-outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="tw-w-6 tw-h-6 tw-text-gray-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                />
              </svg>
            </button>
          </span> -->
          <!--  tw-pl-12 -->
          <!-- <textarea
            v-model="body"
            rows="1"
            type="text"
            placeholder="Escribe un mensaje"
            class="
              tw-w-full
              tw-py-3
              tw-pl-5
              tw-text-gray-600
              tw-flex-1
              tw-placeholder-gray-600
              tw-bg-gray-200
              tw-rounded-full
              tw-overflow-hidden
              tw-resize-none
              focus:tw-outline-none focus:tw-placeholder-gray-400
            "
            @keydown.enter.exact.prevent
            @keyup.enter.exact="submit"
          /> -->
          <v-textarea
            v-model="body"
            :disabled="loading"
            auto-grow
            dense
            outlined
            hide-details=""
            rounded
            class="tw-max-h-64 tw-overflow-y-auto"
            :placeholder="$t('app.msg_placeholder')"
            rows="1"
            @keydown.enter.exact.prevent
            @keyup.enter.exact="submit"
          />
          <!-- </form> -->
          <div class="tw-items-end sm:tw-flex">
            <!-- <div
            class="
              tw-absolute tw-inset-y-0 tw-right-0 tw-items-center tw-hidden
              sm:tw-flex
            "
          > -->
            <!-- <button
              type="button"
              class="
                tw-inline-flex
                tw-items-center
                tw-justify-center
                tw-w-10
                tw-h-10
                tw-text-gray-500
                tw-transition
                tw-duration-500
                tw-ease-in-out
                tw-rounded-full
                hover:tw-bg-gray-300
                focus:tw-outline-none
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="tw-w-6 tw-h-6 tw-text-gray-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                />
              </svg>
            </button>
            <button
              type="button"
              class="
                tw-inline-flex
                tw-items-center
                tw-justify-center
                tw-w-10
                tw-h-10
                tw-text-gray-500
                tw-transition
                tw-duration-500
                tw-ease-in-out
                tw-rounded-full
                hover:tw-bg-gray-300
                focus:tw-outline-none
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="tw-w-6 tw-h-6 tw-text-gray-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </button>
            <button
              type="button"
              class="
                tw-inline-flex
                tw-items-center
                tw-justify-center
                tw-w-10
                tw-h-10
                tw-text-gray-500
                tw-transition
                tw-duration-500
                tw-ease-in-out
                tw-rounded-full
                hover:tw-bg-gray-300
                focus:tw-outline-none
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="tw-w-6 tw-h-6 tw-text-gray-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button> -->
            <button
              v-ripple
              type="submit"
              class="
                tw-inline-flex
                tw-h-10
                tw-w-10
                tw-items-center
                tw-justify-center
                tw-rounded-full
                tw-bg-blue-500
                tw-text-white
                tw-transition
                tw-duration-500
                tw-ease-in-out
                hover:tw-bg-blue-400
                focus:tw-outline-none focus:tw-ring focus:tw-ring-white
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="tw-h-5 tw-w-5 tw-rotate-90 tw-transform"
              >
                <path
                  d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                />
              </svg>
            </button>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import { groupBy, v4 } from '@/helpers'
import { mapState } from 'vuex'
import ChatConversationMessage from './ChatConversationMessage'
import { log } from '@/utils/logging'
import { format } from 'date-fns'
import { VideoChatStateKeys } from '@/enums/VideoChatStateKeys'
import AppBtn from '@/components/App/AppBtn.vue'
import debounce from 'lodash/debounce'
import { realtimeApi } from '@/realtime/api'
import { subscribeChatChannel } from '@/realtime/channels'
import { upsertMessage } from '@/realtime/chatMessages'
import interactsWithChatMessages from '@/mixins/interactsWithChatMessages'

export default {
  components: {
    ChatConversationMessage,
    AppBtn,
  },
  mixins: [interactsWithChatMessages],
  data: () => ({
    loading: true,
    chanel_id: 0,
    body: '',
    messages: [],
    realtimeUnsubscribe: null,
    // sendNotificationDebounced: null,
  }),
  computed: {
    uuids() {
      // Roster-independent room id: order by uuid string (not id) so the receiver
      // can derive the same name from the call signal without knowing our id
      // (users-list-plan.md §4.7b). Must stay in lockstep with chat.js isRinging.
      return [this.user.uuid, this.talking_to.uuid].sort().join('-link-')
    },
    active_channel: {
      get() {
        return this.$store.state.chat.active_channel
      },
      set(value) {
        return this.$store.commit('chat/setState', {
          active_channel: value,
        })
      },
    },
    showChat: {
      get() {
        return this.$store.state.chat.showChat
      },
      set(value) {
        return this.$store.commit('chat/setState', {
          showChat: value,
        })
      },
    },
    sortedMessages() {
      // [{user: ca,messages: [msg]}]
      console.time('Function sortedMessages#1')
      const new_group_by_user = groupBy(
        this.messages.map((row_message) => ({
          ...row_message,
          formated_date: format(
            new Date(row_message.created_at),
            'hh:mm a',
            // 'hh:ii a yyyy-MM-dd',
          ),
          formated_date_stamp: format(
            new Date(row_message.created_at),
            'yyyy-MM-dd',
          ),
        })),
        'formated_date_stamp',
      )
      Object.keys(new_group_by_user).forEach((key) => {
        new_group_by_user[key] = new_group_by_user[key].reduce(
          (previousValue, currentValue, currentIndex) => {
            // console.log('previous ', previousValue)
            log('previous ', currentIndex)
            // console.log('currentValue ', currentValue)
            // console.log('new ', currentValue.user.id)

            const currentMessage = {
              body: currentValue.body,
              id: currentValue.id,
              created_at: currentValue.created_at,
              formated_date: currentValue.formated_date,
              uuid: currentValue.uuid,
              status: currentValue.status,
              failure: currentValue.failure,
            }
            const first = {
              ...currentValue,
              messages: [currentMessage],
            }
            // innitial conditions
            if (previousValue.length === 0) {
              return [...previousValue, first]
            }
            const last_message_in_array =
              previousValue[previousValue.length - 1]
            // check if last message
            if (last_message_in_array.user.id !== currentValue.user.id) {
              return [...previousValue, first]
            }

            previousValue[previousValue.length - 1] = {
              ...last_message_in_array,
              messages: [...last_message_in_array.messages, currentMessage],
            }
            return [...previousValue]
          },
          [],
        )
      })

      console.log(new_group_by_user)

      console.timeEnd('Function sortedMessages#1')

      // return group_by_user
      return new_group_by_user
    },
    ...mapState({
      user: (state) => state.session.user,
      talking_to: (state) => state.chat.talking_to,
      has_video_chat: (state) => state.event.constants.license.has_video_chat,
      registry: (state) => state.event.constants.registry,
    }),
    view: {
      get() {
        return this.$store.state.chat.view
      },
      set(val) {
        this.$store.commit('chat/setState', { view: val })
      },
    },
  },
  watch: {
    talking_to: {
      handler() {
        this.init()
      },
      deep: true,
    },
    showChat: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.scrollToElement()
          })
        }
      },
    },
  },
  async mounted() {
    this.init()
  },
  beforeDestroy() {
    this.unsubscribeRealtime()
    this.active_channel = 0
  },
  methods: {
    unsubscribeRealtime() {
      if (this.realtimeUnsubscribe) {
        this.realtimeUnsubscribe()
        this.realtimeUnsubscribe = null
      }
    },
    async init() {
      this.loading = true
      console.log('mounted chat convo', this.talking_to)
      this.talking_to.id
      const { channel } = await realtimeApi.checkChannel(this.talking_to.id)
      const channelId = channel.id
      log(channelId)
      this.chanel_id = channelId
      this.active_channel = this.chanel_id
      this.unsubscribeRealtime()
      await this.loadLatest(channelId)
      this.realtimeUnsubscribe = subscribeChatChannel(channelId, {
        MessageSent: this.handleNewMessage,
      })
      this.loading = false
      this.$nextTick().then(() => {
        this.scrollToElement()
      })
    },
    startVideoCall() {
      console.log(this.uuids)
      this.$store
        .dispatch('chat/callUser', {
          body: {
            uuids: this.uuids,
            user_uuid: this.user.uuid,
            target_user: this.talking_to,
            target_user_uuid: this.talking_to.uuid,
          },
        })
        .then(() => {
          realtimeApi
            .signalUser({
              status: VideoChatStateKeys.waiting,
              user_uuid: this.user.uuid,
              target_user_uuid: this.talking_to.uuid,
              // Send our computed room id so the receiver uses it verbatim
              // (caller-authoritative; no derivation mismatch).
              room_uuids: this.uuids,
            })
            .then(() => {
              console.log('MOUNTED EventVirtualRoom: triggered ')
            })
            .catch(() => {
              // 503: el realtime no pudo avisar a la otra persona. Se cierra
              // el «llamando…»: nadie va a contestar una llamada que no sonó.
              this.$store.dispatch('chat/closeCall')
              this.$store.dispatch('notifications/addNotification', {
                title: this.$t('app.chat_status.call_failed_title'),
                body: this.$t('app.chat_status.call_failed'),
              })
            })
        })
    },
    viewAttendee() {
      console.log('talking_to')
      console.log(this.talking_to)
      this.$store.commit('event/setCard', {
        attendee: this.talking_to,
        modal: true,
      })
    },
    submit() {
      if (this.body.trim() === '') {
        return
      }
      // Se ve al instante como «Enviando…». El aviso en tiempo real
      // (MessageSent) no le llega a quien escribe (toOthers): lo que confirma
      // el mensaje propio es la respuesta del backend.
      const local = {
        uuid: v4(),
        body: this.body,
        created_at: new Date(),
        status: 'sending',
        user: {
          id: this.user.id,
          uuid: this.user.uuid,
          avatar: this.user.avatar,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
        },
      }
      this.messages = upsertMessage(this.messages, local)
      this.$nextTick().then(() => {
        this.scrollToElement()
      })
      this.sendOwnMessage(local)
      // Keep this conversation in the sender's active chats list (the legacy
      // firstMsgOnChannel mutation kept both participants' lists in sync).
      const activeChats = this.$store.state.chat.active_chats || []
      if (this.talking_to.uuid && !activeChats.includes(this.talking_to.uuid)) {
        this.$store.commit('chat/setState', {
          active_chats: [...activeChats, this.talking_to.uuid],
        })
      }
      this.sendNotificationDebounced(this.body)
      this.body = ''
    },
    storeOwnMessage(local) {
      return realtimeApi.storeMessage(this.chanel_id, {
        message: local.body,
        uuid: local.uuid,
      })
    },
    scrollToElement() {
      const el = this.$refs.scrollToMe
      el.scrollTop = el.scrollHeight
    },
    sendNotificationDebounced: debounce(function (message) {
      this.$store.dispatch('event/newNotificationMessage', {
        event_user_id: this.talking_to.id,
        message: message,
        registry_id: this.registry.id,
      })
    }, 5000),
  },
}
</script>

<style></style>
